'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FEATURES_SECTION = exports.FEATURES_SECTION = 600;
var GUARANTEE_SECTION = exports.GUARANTEE_SECTION = 750;


//////////////////
// WEBPACK FOOTER
// ./js/constants/Breakpoints.js
// module id = 239
// module chunks = 3 4